// General
import React, { Component } from 'react';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import { Button, Modal } from 'react-bootstrap';
// Redux
import { connect } from 'react-redux';
import { closeConfirmationModal } from '../../../actions/siteadmin/modalActions';
import posVerifyConfirmation from '../../../actions/siteadmin/posVerifyConfirmation';

import bt from '../../../components/commonStyle.css';
import s from './PosConfirmModal.css';

class PosConfirmModal extends Component {

  constructor(props) {
    super(props);
  }

  handlePOSStatus = async (bookingId) => {
    const { closeConfirmationModal, posVerifyConfirmation, searchList, currentPage, completedTrips: { refetch } } = this.props;
    const data = await posVerifyConfirmation(bookingId, true, searchList, currentPage)
    let variables = {
      currentPage
    }
    this.setState(variables)
    refetch(variables)
    closeConfirmationModal()
  }
  render() {
    const { closeConfirmationModal, posConfirmModal, bookingId } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <Modal show={posConfirmModal} onHide={closeConfirmationModal} className={cx('wooberlyModal', 'wooberlyModalWidth')}>
        <Modal.Header closeButton>
          <Modal.Title>  <FormattedMessage {...messages['posVerificationLabel']} /></Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass={s.logInModalBody}>
          <div className={s.root}>
            <p className={s.PosModalDescription}> {formatMessage(messages.posVerificationContent)}</p>
            <div className='doubleButtonContainer'>
              <Button onClick={() => closeConfirmationModal()} className={cx(bt.btnSecondary)} type="submit">
                {formatMessage(messages.cancelButton)}
              </Button>
              <Button onClick={() => this.handlePOSStatus(bookingId)} className={cx(bt.btnPrimary)} type="submit">
                {formatMessage(messages.proceed)}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}
const mapState = (state) => ({
  posConfirmModal: state.adminModalStatus.posConfirmModal,
  bookingId: state.adminModalStatus.bookingId
});
const mapDispatch = {
  closeConfirmationModal,
  posVerifyConfirmation
};
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(PosConfirmModal)));

